import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import styled, { css } from 'styled-components';
import query from 'syf-component-library/const/mediaQueries';
import ModalImage from '../../components/ModalImage';
import Alert from '../../components/Alert';
export const Wrapper = styled.div `
  ${({ theme: { spacing }, $withImage, $maxWidth }) => css `
    padding-top: ${$withImage ? spacing.xxlarge : spacing.xlarge}px;
    padding-bottom: ${$withImage ? spacing.xxlarge : spacing.large}px;
    margin-left: ${({ theme }) => theme.spacing.base}px;
    margin-right: ${({ theme }) => theme.spacing.base}px;
    max-width: ${$maxWidth && `${$maxWidth}px`};

    @media ${query.greaterThanSmall} {
      margin-left: ${$maxWidth ? 'auto' : '48px'};
      margin-right: ${$maxWidth ? 'auto' : '48px'};
    }
  `}
`;
const MainLayout = ({ children, withImage: hasImage, maxWidth }) => {
    return (_jsx(Wrapper, Object.assign({ "$withImage": hasImage, "$maxWidth": maxWidth }, { children: children })));
};
export default MainLayout;
const CustomModalImage = styled(ModalImage) `
  margin-left: auto;
  margin-right: auto;
  margin-bottom: ${({ theme }) => theme.spacing.large}px;

  @media ${query.greaterThanMedium} {
    margin-bottom: ${({ theme }) => theme.spacing.xlarge}px;
  }
`;
const Title = styled.h2 `
  font-size: ${({ theme }) => theme.fontSizes.medium}px;
  line-height: ${({ theme }) => theme.lineHeights.medium};
  text-align: center;
`;
const CustomAlert = styled(Alert) `
  margin-bottom: ${({ theme }) => theme.spacing.large}px;
`;
export const LayoutHeading = ({ title, modalImageProps, errorText }) => {
    return (_jsxs(_Fragment, { children: [modalImageProps && (_jsx(CustomModalImage, { imageName: modalImageProps.imageName, alt: modalImageProps.alt })), errorText && _jsx(CustomAlert, Object.assign({ variant: "error" }, { children: errorText })), _jsx(Title, Object.assign({ "$hasImage": !!modalImageProps }, { children: title }))] }));
};
//# sourceMappingURL=index.js.map